import React, { useState } from "react";
import StepperDUC from "../StepperDUC";
import {
    stepLabels,
    stepLabelsDeclinedCommittee,
    stepLabelsDeclinedOfficial,
    stepLabelsDeclinedRecipient
} from "../DUCpage";
import { Stack, Typography } from "@mui/material";
import PlayArrowIcon from "@mui/icons-material/PlayArrow";
import ArrowDropDownIcon from '@mui/icons-material/ArrowDropDown';
import { useGetDUCInfoQuery } from "../../../api/ducApiSlice";
import { useUserInfoQuery } from "../../../api/userApiSlice";


interface props {
    ducData: any
    declinedAIAN: boolean
    expiredAIAN: boolean
    activeStepAIAN: number
    index: number
}


const AIANBlockSteper = (props: props) => {
    const { data: userData } = useUserInfoQuery({});
    const { data: ducDataObject } = useGetDUCInfoQuery({ email: userData?.email });

    const ducDataGen = ducDataObject?.GENERAL?.[0]

    // The AIAN section must remain visible when the General DUC expires ('DucExpired' /
    // 'TrainingExpired' - the statuses the backend actually emits; there is no 'Expired'),
    // otherwise the user's AIAN details vanish as soon as the expiry job runs.
    const generalDucPresent = ['Approved', 'DucExpired', 'TrainingExpired'].includes(ducDataGen?.status)

    const [hide, setHide] = useState(false)

    const handleClick = () => {
        setHide(!hide);
    }

    return (
        <Stack>
            {generalDucPresent &&
                <Stack flexDirection="row" onClick={handleClick}
                    sx={{ "&:hover": { cursor: "pointer" } }}>
                    {hide && <PlayArrowIcon/>}
                    {!hide && <ArrowDropDownIcon fontSize="large"/>}
                    <Typography fontSize="16px" fontWeight="400">
                        Application
                    </Typography>
                </Stack>
            }

            {generalDucPresent && props.ducData?.status !== 'Approved' && props.ducData?.status !== 'DucExpired'
                && !props.declinedAIAN && !hide &&
                !props.expiredAIAN &&
                <StepperDUC
                    declined = {props.declinedAIAN}
                    activeStep={props.activeStepAIAN}
                    stepLabels={stepLabels} />}

            {generalDucPresent && props.ducData?.status  !== 'Approved'
                && props.ducData?.declinedBy === "Official" && !hide &&
                <StepperDUC
                    declined = {props.declinedAIAN}
                    activeStep={props.activeStepAIAN}
                    stepLabels={stepLabelsDeclinedOfficial} />}

            {generalDucPresent && props.ducData?.status  !== 'Approved'
                && props.ducData?.declinedBy === "Committee" && !hide &&
                <StepperDUC
                    declined = {props.declinedAIAN}
                    activeStep={props.activeStepAIAN}
                    stepLabels={stepLabelsDeclinedCommittee} />}

            {generalDucPresent && props.ducData?.status  !== 'Approved'
                && props.ducData?.declinedBy === "Submitter" && !hide &&
                <StepperDUC
                    declined = {props.declinedAIAN}
                    activeStep={props.activeStepAIAN}
                    stepLabels={stepLabelsDeclinedRecipient} />}

            {(props.ducData?.status  === 'Approved' || props.ducData?.status  === 'DucExpired' || props.ducData?.status  === 'TrainingExpired') && !hide &&
                <Stack flexDirection="row" gap={3}>
                    <Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Submission date
                            </Typography>
                            <Typography>
                                {props.ducData?.dateSubmitted}
                            </Typography>
                        </Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Expiration date
                            </Typography>
                            <Typography>
                                {props.ducData?.expiresOn}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Authorized Institutional Business official email
                            </Typography>
                            <Typography>
                                {props.ducData?.signingAuthorityEmail}
                            </Typography>
                        </Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Approval by official
                            </Typography>
                            <Typography>
                                {props.ducData?.dateSignedOfficial || "Not signed yet"}
                            </Typography>
                        </Stack>
                    </Stack>
                    <Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                NBDC Data Access committee email
                            </Typography>
                            <Typography>
                                {props.ducData?.committeeEmail}
                            </Typography>
                        </Stack>
                        <Stack
                            flexDirection="column">
                            <Typography variant="caption">
                                Approval by committee
                            </Typography>
                            <Typography>
                                {props.ducData?.dateSignedCommittee || "Not signed yet"}
                            </Typography>
                        </Stack>
                    </Stack>
                </Stack>}
        </Stack>
    )

}

export default AIANBlockSteper